import Loading from "components/Loading";
import moment from "moment";
import React, { useEffect, useRef } from "react";
import { connect, ConnectedProps, useSelector } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { State } from "state";
import { fetchCoverageReports, resetCoverageReports } from "state/coverage_reports";
import * as xlsx from "xlsx";
import projects from "../assets/img/manage_data/Projects.svg";
import files from "../assets/img/manage_data/files.svg";
import store from "../assets/img/manage_data/store.svg";
import user from "../assets/img/manage_data/user.svg";

import chain from "../assets/img/manage_data/chain.svg";
import chain_parent from "../assets/img/manage_data/chain_parent.svg";
import user_database from "../assets/img/manage_data/user_database.svg";

import ValC from "../assets/img/manage_data/ValC.svg";
import emailAudit from "../assets/img/manage_data/email_audit.svg";
import myser from "../assets/img/manage_data/myser.svg";
import resF from "../assets/img/manage_data/resF.svg";
import review_F from "../assets/img/manage_data/review_F.svg";
import srs from "../assets/img/manage_data/srs.svg";
import star from "../assets/img/manage_data/star.svg";
import upload from "../assets/img/manage_data/upload.svg";

import { useMediaQuery, useTheme } from "@material-ui/core";
import Constants from "helpers/constants";
import { getItem } from "helpers/storage";
import { CHAIN_ROLE, IMPERSONATIONUSER } from "state/auth";


const dataItemsAdmin = [
  // {
  //   title: "Chain",
  //   description: "Manage Chain data records",
  //   route: "/manage-chains",
  //   qa: "chain-button",
  // },
  {
    title: "Store",
    description: "Manage Store data records",
    route: "/manage-all-data/manage-stores",
    qa: "store-button",
    img: store,
  },
  {
    title: "Projects",
    description: "Manage Operations",
    route: "/manage-all-data/projects",
    qa: "store-button",
    img: projects,
  },
  {
    title: "Files",
    description: "Manage File mapping records",
    route: "/manage-all-data/manage-files",
    qa: "files-button",
    img: files,
  },
  {
    title: "User",
    description: "User Store and chain specific role mapping",
    route: "/manage-all-data/manage-mapping-data",
    qa: "user-button",
    img: user,
  },
  // {
  //   title: "User Chain-Store Mapping",
  //   description: "Manage User Chain-Store data records",
  //   route: "/manage-mapping-data",
  //   qa: "user-mapping-button",
  // },
  // {
  //   title: "Chain-Parent",
  //   description: "Manage Chain-Parent records",
  //   route: "/manage-chain-parent-data",
  //   qa: "chain-parent-button",
  // },
];

const dataItems = [
  {
    title: "Store",
    description: "Manage Store data records",
    route: "/manage-all-data/manage-stores",
    qa: "store-button",
    img: store,
  },
  {
    title: "Projects",
    description: "Manage Operations",
    route: "/manage-all-data/projects",
    qa: "store-button",
    img: projects,
  },
  {
    title: "Files",
    description: "Manage File mapping records",
    route: "/manage-all-data/manage-files",
    qa: "files-button",
    img: files,
  },
  {
    title: "User",
    description: "User Store and chain specific role mapping",
    route: "/manage-all-data/manage-mapping-data",
    qa: "user-button",
    img: user,
  },
];

const dataItems2 = [
  {
    title: "Chain-Parent",
    description: "Manage Chain-Parent  records",
    route: "/manage-all-data/manage-chain-parent-data",
    img: chain_parent,
  },
  {
    title: "Manage Chain",
    description: "Manage Chain data records",
    route: "/manage-all-data/manage-chains",
    img: chain,
  },
  {
    title: "User Database",
    description: "Manage User records",
    route: "/manage-all-data/manage-users",
    img: user_database,
  },
  {
    title: "Email Audit Log",
    description: "Track email delivery and status",
    route: "/manage-all-data/email-audit-log",
    img: emailAudit,
  },
];

const dataItems3 = [
  {
    title: "Starred",
    description: "",
    route: "/manage-all-data/starred",
    img: star,
  },
  {
    title: "Validation Completion",
    description: "",
    route: "/manage-all-data/validation-completion",
    img: ValC,
  },
  {
    title: "Review Feedback",
    description: "",
    route: "/manage-all-data/review-feedback",
    img: review_F,
  },
  {
    title: "Store Reset Status",
    description: "",
    route: "/manage-all-data/store-reset-status",
    img: srs,
  },
  {
    title: "Reset Feedback",
    description: "",
    route: "/manage-all-data/store-reset-feedback",
    img: resF,
  },
  {
    title: "Upload Attachments",
    description: "",
    route: "/manage-all-data/upload-attachments",
    img: upload,
  },
  {
    title: "My Surveys",
    description: "",
    route: "/manage-all-data/surveys",
    img: myser,
  },
];

const ManageAllData: React.FC<RouteComponentProps & PropsFromRedux> = ({
  history,
  coverage_reports,
  fetchCoverageReports,
  resetCoverageReports,
}) => {
  const isLoadingRef = useRef(false);
  const [impersonUser, setImpersonUser] = React.useState<any>();

  const authUser = useSelector((state: State) => state.auth_user.content);
  useEffect(() => {
    const storedUser = getItem(IMPERSONATIONUSER);
    if (storedUser) {
      setImpersonUser(JSON.parse(storedUser));
    }
  }, []);
  const parsedData = impersonUser || authUser;
  const userRole = parsedData?.role;
  //const userRole = authUser?.role;

  useEffect(() => {
    if (coverage_reports && isLoadingRef.current) {
      const timestamp = moment(new Date()).format("YYYY-mm-dd_HH-MM-SS");
      const fileName = `${timestamp}_AdminDashboardLiveData.xlsx`;
      xlsx.writeFile(coverage_reports as any, fileName);
      isLoadingRef.current = false;
      resetCoverageReports();
    }
  }, [coverage_reports, resetCoverageReports]);

  const handleExportClick = () => {
    isLoadingRef.current = true;
    fetchCoverageReports();
  };
  const chainPermissionString = getItem(CHAIN_ROLE);
  const chainPermission = JSON.parse(chainPermissionString || "[]");
  const permission = chainPermission;
  const roles = Array.isArray(permission) ? permission : [permission];

  const isProjectAdmin = roles.some(
    (r: any) =>
      r.role_name === "Internal Project Admin" ||
      r.role_name === "External Project Admin"
  );
  let pathValues;
  pathValues = (userRole == 'AB System Admin' || isProjectAdmin) ? dataItemsAdmin : dataItems

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));

  const getGridItemWidth = () => {
    if (isXs) return "100%";   
    if (isSm) return "calc(50% - 10px)"; 
    return "calc(25% - 10px)"; 
  };
  const gridItemResponsive = {
    ...styles.gridItem,
    width: getGridItemWidth(),
  };
  return (
    <div style={styles.main}>

      {/* <Header /> */}

      {/* <BackLink title={"Associated Chains"} path={"/associated-chains"} /> */}

      <section style={styles.container}>
        <div style={styles.sub_container}>
          <h1 style={styles.header}>Manage Master Data</h1>
          <ul style={styles.grid}>
            {pathValues.map((item) => (
              <li key={item.route} onClick={() => history.push(item.route)} style={gridItemResponsive}>
                <div style={{ height: "50px", width: "50px" }}>
                  <img height={50} width={50} src={item.img} alt="logo" style={{ height: "50px", width: "50px", objectFit: "contain" }} />
                </div>

                <div>
                  <h3 style={styles.gridItemTitle}>{item.title}</h3>
                  <p style={styles.gridDesc}>{item.description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* // system-admin section */}

      {userRole === Constants.AB_SYSTEM_ADMIN && (
        <section style={styles.container}>
          <div style={styles.sub_container}>
            <h1 style={styles.header}>System Admin Controls</h1>
            <ul style={styles.grid}>
              {dataItems2.map((item) => (
                <li
                  key={item.route}
                  onClick={() => history.push(item.route)}
                  style={gridItemResponsive}
                >
                  <div style={{ height: "50px", width: "50px" }}>
                    <img height={50} width={50} src={item.img} alt="logo" style={{ height: "50px", width: "50px", objectFit: "contain" }} />
                  </div>

                  <div>
                    <h3 style={styles.gridItemTitle}>{item.title}</h3>
                    <p style={styles.gridDesc}>{item.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </section>
      )}

      {/* // other pages */}

      {userRole === Constants.AB_SYSTEM_ADMIN &&(<section style={styles.container}>
        <div style={styles.sub_container}>
          <h1 style={styles.header}>Other Pages</h1>
          <ul style={styles.grid2}>
            {dataItems3.map((item) => (
              <li
                key={item.route}
                onClick={() => history.push(item.route)}
                // style={styles.gridItem2}
                style={{
                  width: "84px",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                  height: "100px",
                }}
              >
                <div style={styles.gridItem2}>
                  <img height={30} width={30} src={item.img} alt="logo" style={{ height: "30px", width: "30px", objectFit: "contain" }} />
                </div>

                <h3 style={styles.gridItemTitle2}>{item.title}</h3>
              </li>
            ))}
          </ul>
        </div>

        {isLoadingRef.current && (
          <div style={styles.blockUi} className="block-ui">
            <Loading />
          </div>
        )}
      </section>)}
    </div>
  );
};

const connecter = connect(
  (state: State) => ({
    coverage_reports: state.coverage_reports.content,
    loading: state.coverage_reports.loading,
  }),
  {
    fetchCoverageReports,
    resetCoverageReports,
  }
);

type PropsFromRedux = ConnectedProps<typeof connecter>;

export default withRouter(connecter(ManageAllData));

const styles = {
  main: {
    height: "100%",
    width: "100%",
    backgroundColor: "#DFDFDF",
  } as React.CSSProperties,
  container: {
    padding: "0px 0px 20px 0px",
  } as React.CSSProperties,
  sub_container: {
    backgroundColor: "white",
    padding: "16px",
    borderRadius: "16px",
    height: "100%",
  } as React.CSSProperties,
  header: {
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "20px",
  } as React.CSSProperties,
  grid: {
    listStyle: "none",
    padding: 0,
    flexWrap: "wrap",
    display: "flex",
    gap: "10px",
  } as React.CSSProperties,

  grid2: {
    listStyle: "none",
    padding: 0,
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
  } as React.CSSProperties,

  gridItem: {
    border: "1px solid #ddd",
    borderRadius: "16px",
    display: "flex",
    // width: "290px",
    width: "calc(25% - 12px)", // Target 4 items per row (25%) minus half the gap on each side (15px/2 = 7.5px)
    // minWidth: "260px",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "15px",
    padding: "8px 12px",
    boxShadow: "0px 4px 8px 0px #9B202F1A",
    background: "linear-gradient(265.45deg, #FFFDFD 25.4%, #FFFEFE 89.7%, #E3BD21 154%)",

    cursor: "pointer",
  } as React.CSSProperties,

  gridItem2: {
    border: "1px solid #ddd",
    borderRadius: "16px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",
    padding: "8px 12px",

    // width: "60px",
    width: "calc(14.2% - 12px)", // Target 4 items per row (25%) minus half the gap on each side (15px/2 = 7.5px)
    minWidth: "60px",

    height: "54px",
    boxShadow: "0px 4px 8px 0px #9B202F1A",
    background: "linear-gradient(265.45deg, #FFFDFD 25.4%, #FFFEFE 89.7%, #E3BD21 154%)",

    cursor: "pointer",
  } as React.CSSProperties,

  gridItemTitle: {
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "0px",
    lineHeight: "10px",
  } as React.CSSProperties,

  gridItemTitle2: {
    fontSize: "12px",
    fontWeight: 500,
    marginBottom: "0px",
    marginTop: "10px",
    whiteSpace: "pre-wrap",
    width: "84px",
    textAlign: "center",
  } as React.CSSProperties,

  gridDesc: {
    color: "#000",
    fontSize: "12px",
    lineHeight: "14px",
  } as React.CSSProperties,

  blockUi: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  } as React.CSSProperties,
};
